import { useRef, useEffect, useState } from "react";
import { Modal } from "reactstrap";
import { InvestmentHeader, Grid, WhyInvest, FrequentQuestion, InvestNow, InvestmentPlan } from "../components";
import { Navbar, Footer } from "../layouts";
import { useSearchParams } from "react-router-dom";
import { ModalBody } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

const InvestmentPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [modal, setModal] = useState(false)
  const planRef = useRef(null)

 const handleCloseModal = (e) => {
  e.preventDefault()
  searchParams.delete('modal');
  setSearchParams(searchParams)
  setModal(false)
 }
  const handleView = () => {
    planRef.current.scrollIntoView({ behavior: 'smooth' })
  }
  useEffect(() => {
    window.scrollTo({
        top: 0, 
        behavior: 'smooth'
      });
      setModal(searchParams.get("modal") === "true" ? true : false)
}, [searchParams])

  return (
    <>
    <Helmet>
        <title>
          Build wealth with Checkoff Finance | Checkoff Finance Company Limited
        </title>

        <meta
          name="description"
          content="Checkoff Finance offers secure, wealth management solutions to help you grow your money and build wealth with confidence. Licensed & regulated by the Central Bank of Nigeria."
        />

        <meta
          name="keywords"
          content="Checkoff Finance, wealth management Nigeria, save money Nigeria, invest Nigeria, savings app Nigeria, investment company Nigeria, Bankvole, financial planning Nigeria, CBN licensed fintech, grow your wealth Nigeria"
        />

        <meta
          property="og:title"
          content="Wealth Management | Checkoff Finance"
        />

        <meta
          property="og:description"
          content="Secure, reliable wealth management from Checkoff Finance. Licensed by the Central Bank of Nigeria."
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:url"
          content="https://checkoff.finance/wealth-management"
        />

        <meta name="robots" content="index, follow" />

        <link
          rel="canonical"
          href="https://checkoff.finance/wealth-management"
        />
      </Helmet>
      <Navbar investmentPage={true} handleView={handleView}/>
      <Grid />
      <InvestmentHeader handleView={handleView} />
      <WhyInvest handleView={handleView} />
      <InvestmentPlan planRef={planRef}/>
      <InvestNow handleView={handleView} />
      <FrequentQuestion displaySeeMore={true}/>
      <Footer />
      <Modal isOpen={modal} size="sm" centered>
      <ModalBody>
      <p className="text-center" style={{fontSize: "20px", fontWeight: "400"}}>
      Thank you for filling out this form, one of our reps will reach out to you as soon as possible!
      </p>
      <button className="btn btn-primary " onClick={handleCloseModal}>Ok!</button>
      </ModalBody>
      </Modal>
    </>
  );
};

export default InvestmentPage;
